module.exports = __webpack_public_path__ + "static/media/CourseraLogo.51d1fc92.jpg";